/// <reference path="" />


(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }

    /**************************************/
    // Demographic Data View Model
    // Holds the demographic information for an applicant
    /**************************************/
    function DemographicViewModel() {

        var euFeatureEnabled = sm.portal.utility.isEUFeatureEnabled();
        var ukFeatureEnabled = sm.portal.utility.isUKFeatureEnabled();
        var apasFeatureEnabled = sm.portal.utility.isAPASFeatureEnabled();
        // Self-Identification
        var self = this;

        /***  PROPERTIES ***/
        this.ID = ko.observable();
        this.GID = ko.observable();
        this.GenderID = ko.validatedObservable();
        this.GenderIdentityID = ko.validatedObservable();
        this.SexualOrientationID = ko.validatedObservable();
        this.IsAPASApplicant = ko.observable();
        this.CitizenshipItemID = ko.validatedObservable();
        this.CitizenshipItemGID = ko.validatedObservable();
        this.CitizenshipID = ko.validatedObservable();
        this.DualNationalityID = ko.validatedObservable();
        this.BirthCountryID = ko.validatedObservable();
        this.ResidentStateID = ko.validatedObservable();
        this.IndigenousPersonDeclarationID = ko.validatedObservable();
        this.IsVeteranFlag = ko.validatedObservable();
        this.IsHispanicFlag = ko.validatedObservable();
        this.SystemCountryID = ko.validatedObservable();
        this.PermanentResidentFlagID = ko.validatedObservable();
        this.AlienIDNumber = ko.validatedObservable();
        this.PassportNumber = ko.validatedObservable();
        this.RequireVisa = ko.validatedObservable();
        this.VisaTypeID = ko.validatedObservable();
        this.VisaExpirationDate = ko.validatedObservable();
        this.IsPermanentResident = ko.validatedObservable();
        this.HaveWorkPermit = ko.validatedObservable();
        this.HaveStudyPermit = ko.validatedObservable();
        this.EntryDateIntoCanada = ko.validatedObservable();
        this.StudyPermitNumber = ko.validatedObservable();
        this.StudyPermitExpirationDate = ko.validatedObservable();
        this.WorkPermitNumber = ko.validatedObservable();
        this.WorkPermitExpirationDate = ko.validatedObservable();
        this.IsGuardiansAttendedcollege = ko.validatedObservable();

        this.MilitaryServiceID = ko.observable();
        this.MilitaryServiceGID = ko.observable();
        this.MilitaryBranchID = ko.validatedObservable();
        this.MilitaryStatusID = ko.validatedObservable();
        this.DateOfServiceStart = ko.validatedObservable();
        this.DateOfServiceEnd = ko.validatedObservable();

        //UK portal properties
        this.DualNationalityItemID = ko.validatedObservable();
        this.DualNationalityItemGID = ko.validatedObservable();
        this.ReligionID = ko.validatedObservable();
        this.DateOfEntryToUK = ko.validatedObservable();
        this.PassportExpiration = ko.validatedObservable();
        this.PassportIssuePlace = ko.validatedObservable();
        this.VisaNumber = ko.validatedObservable();
        this.CriminalConviction = ko.validatedObservable();
        this.UpdateTemplateProperties = {
            DemographicDescriptionText : ko.observable(''),
            SetNationalityRequired : ko.observable(false),
            SetBirthCountryRequired : ko.observable(false),
            SetEthnicOriginRequired : ko.observable(false),
            SetReligionRequired : ko.observable(false),
            HideDemographicData : ko.observable(false),
            SetGenderRequired : ko.observable(false),
            SetGenderIdentityRequired : ko.observable(false),
            SetSexualOrientationRequired : ko.observable(false),
            DemographicInternationalTemplate : ko.observable(''),
            SummaryDemographicTemplate : ko.observable(''),
            SummaryDemographicVisaTemplate : ko.observable(''),
            HideDemographicText : ko.observable(true)
        }

        sm.portal.vm.custom.setCustomLocalizeKey(self.UpdateTemplateProperties);

        if (ukFeatureEnabled != undefined && ukFeatureEnabled) {
            sm.portal.vm.ukdemographic.InitializeLocalizationProperties(this);
        }


        this.EthnicOriginIDs = ko.observableArray();

        /***  PROPERTIES ***/

        /*** SECTION PROPERTIES ***/
        this.DataLoaded = ko.observable(false);
        this.DataLoading = ko.observable(false);
        this.DataContainer = ko.observable("DemographicContainer");
        this.Touched = ko.observable(false);
        this.DataLoadErrorCount = ko.observable(0);

        this.CountriesDataLoaded = ko.observable(false);
        this.StatesDataLoaded = ko.observable(false);
        /*** SECTION PROPERTIES ***/
        sm.portal.vm.custom.callCustomization('UpdateDemographicProperties', self);

        /*** SUBSECTION PROPERTIES ***/
        this.ShowForeignBornDetails = ko.computed(function () {

            var showForeignBornDetails = false;
            if (!sm.portal.utility.isNullOrEmpty(this.CitizenshipID()) && !sm.portal.utility.isNullOrEmpty(this.SystemCountryID())) {
                if (this.CitizenshipID().toString() != this.SystemCountryID().toString()) {
                    showForeignBornDetails = true;
                }
            }

            if (typeof sm.portal.vm.ukdemographic !== 'undefined' && ukFeatureEnabled) {
                showForeignBornDetails = sm.portal.vm.ukdemographic.ShowForeignBornDetails(this);
            }

            if (!showForeignBornDetails) {
                this.PermanentResidentFlagID(null);
                this.AlienIDNumber(null);
                this.VisaTypeID(null);
                this.VisaExpirationDate(null);
                
                var updatedReqVisa= sm.portal.vm.custom.callCustomization('OverrideRequireVisa');
                if(!sm.portal.utility.isNullOrEmpty(updatedReqVisa)){
                    this.RequireVisa(undefined);
                }else{
                     this.RequireVisa(null);  
                }          
                this.DateOfEntryToUK(null);
                this.PassportExpiration(null);
                this.PassportIssuePlace(null);
                this.VisaNumber(null);
                this.EntryDateIntoCanada(null);
                this.StudyPermitNumber(null);
                this.StudyPermitExpirationDate(null);
                this.WorkPermitNumber(null);
                this.WorkPermitExpirationDate(null);
            }
            
            return showForeignBornDetails;

        }, this);
        this.ShowMilitaryDetails = ko.computed(function () {
            if (!sm.portal.utility.isNullOrEmpty(this.IsVeteranFlag()) && this.IsVeteranFlag() == "true") {
                return true;
            }
            return false;
        }, this);
        /*** SUBSECTION PROPERTIES ***/

        /***  COMPUTED PROPERTIES ***/
        this.FullServiceDates = ko.computed(function () {
            var dates = '';
            if (!sm.portal.utility.isNullOrEmpty(this.DateOfServiceStart())) {
                dates = this.DateOfServiceStart();
            }
            if (!sm.portal.utility.isNullOrEmpty(this.DateOfServiceEnd()) && !sm.portal.utility.isNullOrEmpty(dates)) {
                dates += ' - ' + this.DateOfServiceEnd();
            } else if (!sm.portal.utility.isNullOrEmpty(this.DateOfServiceEnd()) && sm.portal.utility.isNullOrEmpty(dates)) {
                dates = 'Ended: ' + this.DateOfServiceEnd();
            }
            return dates;
        }, this);
        this.AnythingPopulated = ko.computed(function () {

            if (!sm.portal.utility.isNullOrEmpty(this.CitizenshipID())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.BirthCountryID())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.ResidentStateID())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.IsVeteranFlag())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.IsHispanicFlag())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.IndigenousPersonDeclarationID())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.EthnicOriginIDs())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.PermanentResidentFlagID())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.AlienIDNumber())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.PassportNumber())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.VisaTypeID())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.VisaExpirationDate())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.EntryDateIntoCanada())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.StudyPermitNumber())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.StudyPermitExpirationDate())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.WorkPermitNumber())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.WorkPermitExpirationDate())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.IsGuardiansAttendedcollege())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.MilitaryBranchID())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.MilitaryStatusID())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.DateOfServiceStart())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.DateOfServiceEnd())) return true;

            var response = sm.portal.vm.custom.callCustomization('PopulateCustomDemographicData', self);
            if (response != undefined) {
                return response;
            }
            if (typeof sm.portal.vm.ukdemographic !== 'undefined' && ukFeatureEnabled) {
                if (sm.portal.vm.ukdemographic.AnythingPopulated(this)) return true;
            }
            return false;

        }, this);
        /***  COMPUTED PROPERTIES ***/

        /***  LIST DATA PROPERTIES ***/
        this.Countries = ko.observableArray();
        this.States = ko.observableArray();
        this.EthnicOrigins = ko.observableArray();
        this.IndigenousPersonDeclaration = ko.observableArray();
        this.PermanentResidentFlags = ko.observableArray();
        this.VisaTypes = ko.observableArray();
        this.MilitaryBranches = ko.observableArray();
        this.MilitaryStatuses = ko.observableArray();
        this.ReligionOptions = ko.observableArray();
        this.UKCountries = ko.observableArray();
        this.UKCountries.Query = ko.observable('');
        this.Genders = ko.observableArray([]);
        this.GenderIdentities = ko.observableArray([]);
        this.SexualOrientations = ko.observableArray([]);
        /***  LIST DATA PROPERTIES ***/
        
        sm.portal.vm.custom.callCustomization('BuildCountries', self);
        /*** SECTION DRIVING SUBSCRIPTION PROPERTIES ***/
        this.CitizenshipID.subscribe(function (newValue) {
            var sectionsToAdd = Array();
            var sectionsToRemove = Array();

            if (!sm.portal.utility.isNullOrEmpty(this.CitizenshipID()) && !sm.portal.utility.isNullOrEmpty(this.SystemCountryID())) {
                if (this.CitizenshipID().toString() != this.SystemCountryID().toString()) {
                    sectionsToAdd.push({ section: 'Documents', required: false });

                    // Set the section required, since there are required fields in the FB Section
                    viewModel.SetRequired();

                } else {
                    sectionsToRemove.push('Documents');
                }
            } else {
                sectionsToRemove.push('Documents');
            }
            viewModel.MaintainSections(sectionsToAdd, sectionsToRemove);


        }, this);

        /*** SECTION DRIVING SUBSCRIPTION PROPERTIES ***/

        this.handlePermanentResidentChange =  function (newValue) {
            this.IsPermanentResident(false);
            this.HaveWorkPermit(false);
            this.HaveStudyPermit(false);
            this.WorkPermitNumber("");
            this.WorkPermitExpirationDate("");
            this.StudyPermitNumber("");
            this.StudyPermitExpirationDate("");
            for (var i = 0; i < this.PermanentResidentFlags().length; i++) {
                if(this.PermanentResidentFlags()[i].ID() == newValue){
                    if(this.PermanentResidentFlags()[i].FilterField1Value() === "PermanentResidentStatus.PermanentResident"){
                        this.IsPermanentResident(true);   
                    }else if(this.PermanentResidentFlags()[i].FilterField1Value() === "PermanentResidentStatus.WorkPermit"){
                        this.HaveWorkPermit(true);
                    }else if(this.PermanentResidentFlags()[i].FilterField1Value() === "PermanentResidentStatus.StudyPermit"){
                        this.HaveStudyPermit(true);
                    }
                }
            }
            if(!(this.IsPermanentResident() || this.HaveWorkPermit() || this.HaveStudyPermit())) this.EntryDateIntoCanada("");
        };
        this.handleCitizenshipIDChange = function (newValue) {
            self.IndigenousPersonDeclarationID(null);
        };

        /*** SECTION METHODS ***/
        this.LoadModel = function (container) {
            // update application section configurations
            if (container && container.Payload && container.Payload.Config) {
                viewModel.SetSectionsConfigData("Demographic", container.Payload.Config);
            }
            var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();
            var extraData = {
                self: self,
                container: container
            }
            sm.portal.vm.custom.callCustomization('LoadExtraData', extraData, 
                function () {
                    self.EthnicOrigins = smapi.access.loadListItemModels(container.Payload.ListData.EthnicOrigins, self.EthnicOrigins); 
                    if (container.Payload.Demographic != null) {
                        self.VisaTypeID(container.Payload.Demographic.VisaTypeID);
                        if (container.Payload.Demographic.VisaExpirationDate != null && container.Payload.Demographic.VisaExpirationDate != undefined) {
                            self.VisaExpirationDate(moment(new Date(container.Payload.Demographic.VisaExpirationDate)).format(dateFormat));
                        }        
                    }                   
                }
            );

            this.PermanentResidentFlags = smapi.access.loadListItemModels(container.Payload.ListData.PermanentResidentFlags, this.PermanentResidentFlags);
            this.MilitaryBranches = smapi.access.loadListItemModels(container.Payload.ListData.MilitaryBranches, this.MilitaryBranches);
            this.MilitaryStatuses = smapi.access.loadListItemModels(container.Payload.ListData.MilitaryStatuses, this.MilitaryStatuses);
            this.VisaTypes = smapi.access.loadListItemModels(container.Payload.ListData.VisaTypes, this.VisaTypes);
            this.IndigenousPersonDeclaration = smapi.access.loadListItemModels(container.Payload.ListData.IndigenousPersonDeclaration, this.IndigenousPersonDeclaration);

            var res = sm.portal.vm.custom.callCustomization('LoadDemographicExtraData', extraData);

            self.IsAPASApplicant(container.Payload.IsAPASApplicant);

            if (container.Payload.Demographic != null && sm.portal.utility.isNullOrEmpty(res)) {
                this.ID(container.Payload.Demographic.ID);
                this.GID(container.Payload.Demographic.GID);

                this.CitizenshipItemID(container.Payload.Demographic.CitizenshipItemID);
                this.CitizenshipItemGID(container.Payload.Demographic.CitizenshipItemGID);
                this.CitizenshipID(container.Payload.Demographic.CitizenshipID);
                this.BirthCountryID(container.Payload.Demographic.BirthCountryID);
                this.ResidentStateID(container.Payload.Demographic.ResidentStateID);
                this.IsVeteranFlag(container.Payload.Demographic.IsVeteranFlag.toString());
                this.IsHispanicFlag(container.Payload.Demographic.IsHispanicFlag.toString());
                this.IndigenousPersonDeclarationID(container.Payload.Demographic.IndigenousPersonDeclarationID);
                this.PassportNumber(container.Payload.Demographic.PassportNumber);

                for (var i = 0; i < container.Payload.Demographic.EthnicOriginIDs.length; i++) {
                    this.EthnicOriginIDs.push(container.Payload.Demographic.EthnicOriginIDs[i].toString());
                }

                this.PermanentResidentFlagID(container.Payload.Demographic.PermanentResidentFlagID);
                this.handlePermanentResidentChange(this.PermanentResidentFlagID());
                this.AlienIDNumber(container.Payload.Demographic.AlienIDNumber);
                self.VisaTypeID(container.Payload.Demographic.VisaTypeID);
                if (container.Payload.Demographic.VisaExpirationDate != null && container.Payload.Demographic.VisaExpirationDate != undefined) {
                    self.VisaExpirationDate(moment(new Date(container.Payload.Demographic.VisaExpirationDate)).format(dateFormat));
                }     

                this.MilitaryServiceID(container.Payload.Demographic.MilitaryServiceID);
                this.MilitaryServiceGID(container.Payload.Demographic.MilitaryServiceGID);
                this.MilitaryBranchID(container.Payload.Demographic.MilitaryBranchID);
                this.MilitaryStatusID(container.Payload.Demographic.MilitaryStatusID);
                if (container.Payload.Demographic.EntryDateIntoCanada) {
                    self.EntryDateIntoCanada(moment(new Date(container.Payload.Demographic.EntryDateIntoCanada)).format(dateFormat));
                    if (self.EntryDateIntoCanada().includes('1900')) {
                        self.EntryDateIntoCanada('');
                    }
                }  
                this.StudyPermitNumber(container.Payload.Demographic.StudyPermitNumber);
                if (container.Payload.Demographic.StudyPermitExpirationDate) {
                    self.StudyPermitExpirationDate(moment(new Date(container.Payload.Demographic.StudyPermitExpirationDate)).format(dateFormat));
                    if (self.StudyPermitExpirationDate().includes('1900')) {
                        self.StudyPermitExpirationDate('');
                    }
                }
                this.WorkPermitNumber(container.Payload.Demographic.WorkPermitNumber);
                if (container.Payload.Demographic.WorkPermitExpirationDate) {
                    self.WorkPermitExpirationDate(moment(new Date(container.Payload.Demographic.WorkPermitExpirationDate)).format(dateFormat));
                    if (self.WorkPermitExpirationDate().includes('1900')) {
                        self.WorkPermitExpirationDate('');
                    }
                }
                this.IsGuardiansAttendedcollege(container.Payload.Demographic.IsGuardiansAttendedcollege);

                if (container.Payload.Demographic.DateOfServiceStart != null && container.Payload.Demographic.DateOfServiceStart != undefined) {
                    self.DateOfServiceStart(moment(container.Payload.Demographic.DateOfServiceStart, 'YYYY-MM-DDTHH:mm:ss').format(dateFormat));
                } else {
                    self.DateOfServiceStart(container.Payload.Demographic.DateOfServiceStart);
                }
                if (container.Payload.Demographic.DateOfServiceEnd != null && container.Payload.Demographic.DateOfServiceEnd != undefined) {
                    self.DateOfServiceEnd(moment(container.Payload.Demographic.DateOfServiceEnd, 'YYYY-MM-DDTHH:mm:ss').format(dateFormat));
                } else {
                    self.DateOfServiceEnd(container.Payload.Demographic.DateOfServiceEnd);
                }
            }

            sm.portal.vm.custom.callCustomization('GetAdditionalDemographicData', extraData,
                function () {
                    if (typeof sm.portal.vm.ukdemographic !== 'undefined' && ukFeatureEnabled) {
                        sm.portal.vm.ukdemographic.LoadModel(self, container);
                    }
        
                    if (typeof sm.portal.vm.apasdemographic !== 'undefined' && apasFeatureEnabled) {
                        sm.portal.vm.apasdemographic.LoadModel(self, container);
                    }                            
                }
            );

            this.DataLoading(false);
            this.DataLoaded(true);
            if (smapi.constant.applicationDebugFlag) { console.log('[DemographicVM] Data Loaded'); }
        };

        this.GetModelData = function (blockui, applicationMID, personMID, callback) {
            
            if (!this.DataLoaded() && !this.DataLoading()) {

                this.DataLoading(true);
                if(!sm.portal.utility.isNullOrEmpty(viewModel.allCustomData())) {
                    var custData = {
                        personMID : personMID,
                        self : self
                    }
                    sm.portal.vm.custom.callCustomization('GetDemographicModelData', custData);
                    self.LoadModel(viewModel.allCustomData().Demographic);
                    callback && callback(viewModel.allCustomData().Demographic);
                    
                    return;
                }
                if (blockui) { jQuery.blockUI(); }
                var url = _baseApiUri + sm.portal.utility.formatString('api/studentportal/getapplicationsection?sectionName=demographic&attemptmid={0}', applicationMID);

                jQuery.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    headers: {
                        "x-api-version": '1' //,
                    },
                    processData: false,
                    crossDomain: true,

                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data, textStatus, jqXHR) {
                        sm.portal.page.application.modelDataResponseHandler(self, data, applicationMID, personMID);
                        callback && callback(data);
                    },
                    error: function (jqXHR, exception) {
                        sm.portal.page.application.modelErrorHandler(self, jqXHR);
                        sm.portal.page.application.handleErrorWithMessages(self, jqXHR, 'fetch');
                        callback && callback();
                    }
                });

                var custData = {
                    personMID : personMID,
                    self : self
                }
                sm.portal.vm.custom.callCustomization('GetDemographicModelData', custData);
            }
            else {
                callback && callback();
            }
        };
        this.BlockContainer = function () {
            jQuery("#" + self.DataContainer()).block({ message: sm.portal.utility.getResourceValue('Loading') });
        };
        this.UnBlockContainer = function () {
            jQuery("#" + self.DataContainer()).unblock();
            viewModel.SetFocus();
        };
        this.ProcessOnServer = function () {
            return true;
        };
        this.ExtractATO = function () {
            // [EXTEND] New fields added to view model need to be updated here
            var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();
            var demoMain;
            var demoMain = sm.portal.vm.custom.callCustomization('ExtractDemographicATO', self);
            if (sm.portal.utility.isNullOrEmpty(demoMain)) {
                demoMain = new smapi.community.DemographicDataModel({
                    IsHispanic: self.IsHispanicFlag(),
                    BirthCountryID: self.BirthCountryID(),
                    ResidentStateID: self.ResidentStateID(),
                    Veteran: self.IsVeteranFlag,
                    IndigenousPersonDeclarationID: self.IndigenousPersonDeclarationID() ? self.IndigenousPersonDeclarationID() : null,
                    ID: self.ID(),
                    GID: self.GID(),
                    NumOfDependents: null,
                    NumOfDependentsInHousehold: null,
                    BirthCity: null,
                    DriversLicense: null,
                    IsGuardiansAttendedcollege: self.IsGuardiansAttendedcollege()
                });
            }

            // TODO: NOTE: The Many-to-Many relationships shouldn't be part of the defaults list, or should they?
            demoMain.EthnicOrigins = self.EthnicOriginIDs();

            if (!sm.portal.utility.isNullOrEmpty(self.MilitaryBranchID()) && self.MilitaryBranchID() > 0) {
                var dateOfServiceStart = moment(self.DateOfServiceStart(), dateFormat).format('YYYY-MM-DD');
                var dateOfServiceEnd = moment(self.DateOfServiceEnd(), dateFormat).format('YYYY-MM-DD');
                var military = new smapi.community.MilitaryServiceModel({
                    BranchID: self.MilitaryBranchID(),
                    MilitaryStatusID: self.MilitaryStatusID(),
                    DateOfServiceFrom: dateOfServiceStart,
                    DateOfServiceTo: dateOfServiceEnd,
                    ID: self.MilitaryServiceID(),
                    GID: self.MilitaryServiceGID(),
                    PrimaryAFSC: null,
                    SecondaryAFSC: null,
                    TertiaryAFSC: null,
                    QuaternaryAFSC: null,
                    Unit: null,
                    PromotionLineNumber: null,
                    EligibleForReinstatement: null
                });

                sm.portal.vm.custom.callCustomization('UpdateMilitaryProps', military);
                demoMain.MilitaryService().push(military);
            }

            if (!sm.portal.utility.isNullOrEmpty(self.CitizenshipID()) && self.CitizenshipID() > 0) {
                
                var citizenship = sm.portal.vm.custom.callCustomization('UpdateATOData', self);
                if (sm.portal.utility.isNullOrEmpty(citizenship)) {
                    citizenship = new smapi.community.CitizenshipModel({
                        CountryID: self.CitizenshipID(),
                        PassportNumber: self.PassportNumber(),
                        PermanentResidentStatusID: self.PermanentResidentFlagID(),
                        VisaTypeID: self.VisaTypeID(),
                        VisaExpirationDate: self.VisaExpirationDate(),
                        AlienIDNumber: self.AlienIDNumber(),
                        ID: self.CitizenshipItemID(),
                        GID: self.CitizenshipItemGID(),
                        NationalID: null,
                        EntryDateIntoCanada: self.EntryDateIntoCanada() ? self.EntryDateIntoCanada() : '01/01/1900',
                        StudyPermitNumber : self.StudyPermitNumber(),
                        StudyPermitExpirationDate: self.StudyPermitExpirationDate() ? self.StudyPermitExpirationDate() : '01/01/1900',
                        WorkPermitNumber : self.WorkPermitNumber(),
                        WorkPermitExpirationDate: self.WorkPermitExpirationDate() ? self.WorkPermitExpirationDate() : '01/01/1900'
                    });                        
                }
                var customData = {
                    citizenship: citizenship,
                    self: self
                }
                var citizenshipUpdated = sm.portal.vm.custom.callCustomization('UpdateCitizenshipProps', customData);
                if(!sm.portal.utility.isNullOrEmpty(citizenshipUpdated)){
                    citizenship = citizenshipUpdated;
                }
                demoMain.Citizenships().push(citizenship);
            }
            var additionData = {
                self: self,
                demoMain: demoMain
            }
            sm.portal.vm.custom.callCustomization('GetAditionalDemographicATO', additionData, 
                function () {
                    if (typeof sm.portal.vm.eudemographic !== 'undefined' && euFeatureEnabled) {
                        sm.portal.vm.eudemographic.ExtractATO(self, demoMain);
                    }
                    if (typeof sm.portal.vm.ukdemographic !== 'undefined' && ukFeatureEnabled) {
                        sm.portal.vm.ukdemographic.ExtractATO(self, demoMain);
                    }                            
                }
            );
            return demoMain;
        };
        /*** SECTION METHODS ***/
        sm.portal.vm.custom.callCustomization('OverrideDemographicValidation', self);

        /*** VALIDATION METHODS ***/
        this.CitizenshipID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BirthCountryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ResidentStateID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SystemCountryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PermanentResidentFlagID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.IndigenousPersonDeclarationID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AlienIDNumber.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.PassportNumber.extend({
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            }
        });
        this.VisaTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.VisaExpirationDate.extend({
            smLocalDate: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.MilitaryServiceID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MilitaryBranchID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MilitaryStatusID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DateOfServiceStart.extend({
            smLocalDate: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.DateOfServiceEnd.extend({
            smLocalDate: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.GenderID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GenderIdentityID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SexualOrientationID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DualNationalityID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ReligionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DateOfEntryToUK.extend({
            smLocalDate: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.PassportExpiration.extend({
            smLocalDate: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.PassportIssuePlace.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.VisaNumber.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.EntryDateIntoCanada.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return apasFeatureEnabled && (self.IsPermanentResident() || self.HaveWorkPermit() || self.HaveStudyPermit());
                }
            },
            smLocalDate: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StudyPermitNumber.extend({
            pattern:{
                params: /^[A-Za-z0-9 -]+$/g,
                message: sm.resources.portalResource.getValue('PermitNumberValidationMessage')
            },
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.StudyPermitExpirationDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.StudyPermitNumber();
                }
            },
            smLocalDate: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.WorkPermitNumber.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return apasFeatureEnabled && self.HaveWorkPermit();
                }
            },
            pattern:{
                params: /^[A-Za-z0-9 -]+$/g,
                message: sm.resources.portalResource.getValue('PermitNumberValidationMessage')
            },
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.WorkPermitExpirationDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.WorkPermitNumber();
                }
            },
            smLocalDate: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            },
        });
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        // Check if Model is valid 
        // (will NOT validate attached models, unless we
        //  init that in ui.js - currently it has performance problems)
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        this.Completed = ko.computed(function () {
            // No Required Fields
            var isCompleted = this.IsVMValid() && (this.AnythingPopulated() || this.Touched());
            return isCompleted

        }, this);
        /*** VALIDATION METHODS ***/

        return self;
    };

    jQuery.extend(true, sm.portal.vm, {
        DemographicViewModel: DemographicViewModel,
    });

})(jQuery);